import { useRef, useEffect } from 'react';
import { Textarea as WindmillTextarea } from '@windmill/react-ui';
import { TextareaProps } from '@windmill/react-ui/dist/Textarea';

interface CustomTextareaProps extends TextareaProps {
  ariaLabel?: string;
}

const Textarea = (props: CustomTextareaProps) => {
  const textareaRef = useRef<HTMLTextAreaElement | null>(null);
  const { ariaLabel, rows } = props;

  useEffect(() => {
    if (textareaRef && textareaRef.current) {
      const rowsHeight = rows ? textareaRef.current.offsetHeight : 0;
      textareaRef.current.style.height = '0px';
      const { scrollHeight } = textareaRef.current;
      textareaRef.current.style.height = `${Math.max(scrollHeight, rowsHeight)}px`;
    }
  }, []);

  return (
    <>
      <WindmillTextarea
        ref={textareaRef}
        aria-label={ariaLabel}
        onPointerEnterCapture={() => {}}
        onPointerLeaveCapture={() => {}}
        css=""
        {...props}
      />
    </>
  );
};

export default Textarea;
